/**
 * GraphQL query to fetch comprehensive order details
 * 
 * This query retrieves:
 * - Order basic information (id, name, email, phone, timestamps)
 * - Order pricing (total price with currency)
 * - Line items (products, variants, quantities, custom attributes)
 * - Customer information (name, email, display name)
 * - Custom metafields (namespace: "custom_orders")
 * - Order tags
 * 
 * Used as a fallback when the API object doesn't provide sufficient order data.
 */
export const GET_ORDER_DETAILS_QUERY = `
  query getOrder($id: ID!) {
    order(id: $id) {
      id
      name
      email
      phone
      createdAt
      updatedAt
      totalPriceSet {
        shopMoney {
          amount
          currencyCode
        }
      }
      lineItems(first: 50) {
        edges {
          node {
            id
            title
            quantity
            product {
              id
              tags
            }
            variant {
              id
              title
            }
            customAttributes {
              key
              value
            }
          }
        }
      }
      customer {
        firstName
        lastName
        displayName
        email
      }
      metafields(first: 50, namespace: "custom_orders") {
        edges {
          node {
            key
            value
            namespace
          }
        }
      }
      tags
    }
  }
`;

